<template>
    <platform-add-form></platform-add-form>
</template>


<script>

    import PlatformAddForm from '../../add/representations/WizardForm'

    export default {

        components:{
            PlatformAddForm,
        },

    }
</script>

